
import { LensInventory, LensFormValues } from "@/types/inventory";
import { UseFormReturn } from "react-hook-form";
import { AddLensForm } from "@/components/inventory/AddLensForm";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

interface EditLensDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  lens: LensInventory;
  form: UseFormReturn<LensFormValues>;
  onSubmit: (values: LensFormValues) => Promise<void>;
}

export function EditLensDialog({
  isOpen,
  setIsOpen,
  lens,
  form,
  onSubmit
}: EditLensDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-4xl sm:max-w-4xl md:max-w-4xl w-[95%]">
        <DialogHeader>
          <DialogTitle>Edit Lens</DialogTitle>
          <DialogDescription>
            Update the details of your {lens?.brand} {lens?.lens_name}
          </DialogDescription>
        </DialogHeader>
        <AddLensForm form={form} onSubmit={onSubmit} isEditing={true} />
      </DialogContent>
    </Dialog>
  );
}
